<script lang="ts">
  export let params
  const getTrace = async () => {
    const response = await fetch(`https://tendancetrail.fr/wp-json/wp/v2/tracegpx/${params.traceId}?_fields=id,title,content,gpx,image,distance,elevation,duration,city`);
    const jsonResponse = await response.json()
    return jsonResponse
  }
  const trace = getTrace()
  console.log(trace)
</script>

  {#await trace}
    <p class="text-center">Récupération de la trace...</p>
  {:then trace}
  <div class="max-w-lg m-auto">
    <div class="flex items-center mb-6">
      <a href="/">
        <svg class="w-6 h-6 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
        </svg>
      </a>
      <h2 class="font-bold uppercase text-xl lg:text-3xl">{trace.title.rendered}</h2>
    </div>
    <div class="mb-4">
      <img class="w-full rounded shadow-xl" src={trace.image} alt="Sunset in the mountains">
    </div>
  </div>
  <div class="container md:flex md:justify-center">
    <div class="max-w-lg px-6 py-4">
      <div class="flex items-center text-gray-700 pb-1">
        <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
        <p class="gpx-from capitalize font-bold pl-1">{trace.city}</p>
      </div>
      <div class="text-gray-700 text-base mb-2">
        {@html trace.content.rendered}
      </div>
      <div class="mb-2">
        <span class="inline-block bg-gray-400 rounded-full text-xs lg:text-sm px-2 py-1 font-semibold text-white mr-2 mb-2">{trace.distance} km</span>
        <span class="inline-block bg-gray-400 rounded-full px-2 py-1 text-xs lg:text-sm font-semibold text-white mr-2 mb-2">{trace.elevation} d+</span>
        <span class="inline-block bg-gray-400 rounded-full px-2 py-1 text-xs lg:text-sm font-semibold text-white mr-2 mb-2">{trace.duration}h</span>
      </div>
      <div class="">
        <a href={trace.gpx}>
          <button class="ttrail-bg-color text-white font-bold py-2 px-4 rounded shadow-xl inline-flex items-center">
            <svg class="fill-current w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
            <span>Télécharger</span>
          </button>
        </a>
      </div>
    </div>
  </div>
  {/await}
<style>
  h2 {
    font-family: miller-banner, 'BlinkMacSystemFont', -apple-system, 'Roboto', 'Lucida Sans';
  }
  .ttrail-color {
    color: #00b894;
  }

  .ttrail-bg-color {
    background: #00b894;
  }
</style>
